export default "__VITE_ASSET__d281e0eb__"